/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React, { useEffect, useState } from "react";
import PersonalDetails from "../components/PersonalDetails/PersonalDetails";
import SignUp from "../components/SignUp/SignUp";
import Verification from "../components/Verification/Verification";
import WorkDetails from "../components/WorkDetails/WorkDetails";
import WorkSizeDetails from "../components/WorkSizeDetails/WorkSizeDetails";
import ActivatingAccount from "../components/ActivatingAccount/ActivatingAccount";
import ConfirmActivation from "../components/ConfirmActivation/ConfirmActivation";
import FailedActivation from "../components/FailedActivation/FailedActivation";
import EmailVerification from "../components/EmailVerification/EmailVerification";
import OwnerDetails from "../components/OwnerDetails/OwnerDetails";

/**
 * Wrapper container called in App.js
 * Wrapper conatiner contain all the page
 * and render then on the basis of updated state
 *
 * @returns Current page component
 */
const Wrapper = () => {
  // State for current page
  const [page, setPage] = useState("Signup");
  // State for user job role
  const [jobRole, setJobRole] = useState(null);
  // State for user type if user is owner operator or company
  const [org, setOrg] = useState(null);
  // State for if user is invited or not
  const [isInvited, setIsInvited] = useState(false);
  // State for if user is employee or not
  const [isEmployee, setIsEmpolyee] = useState(false);

  /**
   * Handle user invitation scenario
   * store query params in local storage
   */
  useEffect(() => {
    let url = window.location.href;
    const urlObj = new URL(url);
    const queryParams = new URLSearchParams(urlObj.search);

    if (queryParams.has("mobile")) {
      localStorage.clear();
      let mobileNumber = queryParams.get("mobile");
      localStorage.setItem("mobileNumber", `+${mobileNumber.trim()}`);
      if (queryParams.has("payload")) {
        let payload = queryParams.get("payload");
        localStorage.setItem("payload", payload);
      }
    }
    setPage("SignUp");
  }, []);

  // Show sign up page
  if (page === "SignUp") {
    return <SignUp setPage={setPage} setJobRole={setJobRole} isInvited={isInvited} />;
  }

  // Show verification page
  if (page === "Verification") {
    return <Verification setPage={setPage} isInvited={isInvited} />;
  }

  // Show Your details page
  if (page === "PersonalDetails") {
    return (
      <PersonalDetails
        setPage={setPage}
        jobRole={jobRole}
        setJobRole={setJobRole}
        isInvited={isInvited}
        setIsInvited={setIsInvited}
      />
    );
  }

  // Show Owner details page
  if (page === "OwnerDetails") {
    return (
      <OwnerDetails
        setPage={setPage}
        jobRole={jobRole}
        setJobRole={setJobRole}
        isInvited={isInvited}
        setIsInvited={setIsInvited}
      />
    );
  }

  // Show work details employee count page
  if (page === "WorkDetails") {
    return <WorkDetails setPage={setPage} org={org} setOrg={setOrg} />;
  }

  // show work details comapany details page
  if (page === "WorkSizeDetails") {
    return <WorkSizeDetails setPage={setPage} org={org} isInvited={isInvited} isEmployee={isEmployee} jobRole={jobRole}/>;
  }

  // Show activating account page
  if (page === "ActivatingAccount") {
    return <ActivatingAccount setPage={setPage} isInvited={isInvited} jobRole={jobRole} />;
  }

  // Show Account Activated page
  if (page === "AccountActivated") {
    return <ConfirmActivation setPage={setPage} />;
  }

  // Show Account Activation failed page
  if (page === "AccountFailed") {
    return <FailedActivation />;
  }

  if (page === "EmailVerification") {
    return <EmailVerification setPage={setPage} isInvited={isInvited} jobRole={jobRole} />;
  }
};

export default Wrapper;
